import { Component, Input } from '@angular/core';
import { AdPlacementStageForm } from '../../forms/ad-placement-stage.form';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePickerComponent } from '../../../../../../../../common/date-picker/date-picker.component';
import { CommonModule } from '@angular/common';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import {
  ExposedMapControlComponent
} from '../../../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import { ParcelsCrudComponent } from '../../../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { NgxMaskDirective } from 'ngx-mask';
import {
  RoadControlsSetComponent
} from '../../../../../common/components/road-controls-set/road-controls-set.component';

@Component({
  selector: 'app-ad-placement-stage-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DatePickerComponent,
    CommonModule,
    ValidationErrorsComponent,
    ExposedMapControlComponent,
    ParcelsCrudComponent,
    NgxMaskDirective,
    RoadControlsSetComponent
  ],
  templateUrl: './ad-placement-stage-form.component.html'
})
export class AdPlacementStageFormComponent {
  @Input()
  public label: string = '';

  @Input()
  public form: AdPlacementStageForm | undefined;
}
